import Route from '@ember/routing/route';

export default class MarketRevenueInsightIssueTableRoute extends Route {}
